module.exports = __webpack_public_path__ + "assets/icons/splash-background.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/splash/splash-background.jpg
// module id = ./src/styles/icons/splash/splash-background.jpg
// module chunks = 0